import { render, staticRenderFns } from "./AllInsights.vue?vue&type=template&id=578367b4&scoped=true"
import script from "./AllInsights.vue?vue&type=script&lang=js"
export * from "./AllInsights.vue?vue&type=script&lang=js"
import style0 from "./AllInsights.vue?vue&type=style&index=0&id=578367b4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "578367b4",
  null
  
)

export default component.exports